import React from 'react';
import { Link } from 'react-router-dom';
import { Clock, Home } from 'lucide-react';

const MeetingLinkExpired: React.FC = () => (
  <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 flex items-center justify-center p-4">
    <div className="max-w-md w-full bg-slate-800/80 backdrop-blur-sm border border-white/10 rounded-2xl p-8 text-center">
      <div className="w-16 h-16 mx-auto mb-5 rounded-full bg-amber-500/20 flex items-center justify-center">
        <Clock className="w-8 h-8 text-amber-400" />
      </div>
      <h1 className="text-2xl font-bold text-white mb-3">Toplantı linki geçersiz</h1>
      <p className="text-gray-400 text-sm leading-relaxed mb-6">
        Bu online toplantı linki oluşturulduktan 1 saat sonra geçersiz hale gelir.
        Yeni bir toplantı başlatmanız veya güncel bir davetiye almanız gerekir.
      </p>
      <div className="flex flex-col sm:flex-row gap-3 justify-center">
        <Link
          to="/dashboard"
          className="inline-flex items-center justify-center gap-2 px-5 py-2.5 bg-purple-600 hover:bg-purple-700 text-white rounded-xl font-semibold transition"
        >
          <Home className="w-4 h-4" />
          Panele dön
        </Link>
        <Link
          to="/plans"
          className="inline-flex items-center justify-center px-5 py-2.5 bg-white/10 hover:bg-white/20 text-white rounded-xl font-medium transition"
        >
          Toplantı planla
        </Link>
      </div>
    </div>
  </div>
);

export default MeetingLinkExpired;
